import { render, staticRenderFns } from "./modalOrdenarSecciones.vue?vue&type=template&id=afab256e&scoped=true"
import script from "./modalOrdenarSecciones.vue?vue&type=script&lang=js"
export * from "./modalOrdenarSecciones.vue?vue&type=script&lang=js"
import style0 from "./modalOrdenarSecciones.vue?vue&type=style&index=0&id=afab256e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afab256e",
  null
  
)

export default component.exports